import { useNavigate } from "react-router-dom";
import { useTranslation } from "../i18n";
import "./SubscriptionCancel.css";

export default function SubscriptionCancel() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const isOnboarding = localStorage.getItem("viewsday_onboarding_in_progress") === "true";

  const handleBackToPlans = () => {
    navigate("/pricing");
  };

  const handleContinueFree = () => {
    localStorage.removeItem("viewsday_onboarding_in_progress");
    navigate("/onboarding?step=2");
  };

  return (
    <div className="sc-page">
      <div className="sc-card">
        <div className="sc-icon">✕</div>
        <h1 className="sc-title">{t("subscription.cancelTitle")}</h1>
        <p className="sc-desc">{t("subscription.cancelDesc")}</p>

        <div className="sc-actions">
          <button className="btn-primary btn-md" onClick={handleBackToPlans}>
            {t("subscription.backToPlans")}
          </button>
          {isOnboarding && (
            <button className="btn-ghost btn-md" onClick={handleContinueFree}>
              {t("subscription.continueWithCurrentPlanBtn")}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
